// @ts-nocheck
/* eslint-disable */
import * as registry from '../../registry.js'
/**
* @param {{  }} i
*/
export const attendingPrompt_noUpdatesDetail = (i) => `You won't know if the event is cancelled or if the organizer makes important changes.`